import React, { useEffect, useState } from 'react';
import axios from 'axios';
import logo from '../img/logo.png'

export const WordpressLogo = () => {
  const [logoUrl, setLogoUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_PAY_BASE_URL}/wp-json/custom/v1/logo`);
        setLogoUrl(response.data.logo_url);
      } catch (err) {
        setError('Error fetching logo');
      } finally {
        setLoading(false);
      }
    };

    fetchLogo();
  }, []);

  return (
    <div>
      {logoUrl ? <img src={logoUrl} className='h-8' alt="Site Logo" /> : <img src={logo} className='h-8' alt="Site Logo" />}
    </div>
  );
};
